import cx from 'classnames'
import Styles from 'components/Wizards/SelectImages/GeneratedImage.module.scss'
import { Checkbox } from 'blaze-ui/Checkbox'
import { useField } from 'formik'
import { ImageCheckboxProps } from './Types'

export const ImageCheckbox = ({ url, alt, value }: ImageCheckboxProps) => {
  const checkboxValue = value || url

  // Handle selected_images field (just URLs)
  const [selectedImagesField, , { setValue: setSelectedImagesValue }] = useField<string[]>('selected_images')

  // Handle featured_selected_images field (objects with url and alt_text)
  const [featuredImagesField, , { setValue: setFeaturedImagesValue }] = useField<
    Array<{
      url: string
      alt_text: string
    }>
  >('featured_selected_images')

  const isSelected = selectedImagesField.value.includes(checkboxValue)

  const imageData = {
    url: checkboxValue,
    alt_text: alt,
  }

  return (
    <div className={cx(Styles.checkboxLabel, { [Styles.selected]: isSelected })}>
      <Checkbox.Label
        isSelected={isSelected}
        aria-label={`Select file ${url}`}
        onChange={(isSelected) => {
          if (isSelected) {
            // Add URL to selected_images and object to featured_selected_images
            setSelectedImagesValue([...selectedImagesField.value, checkboxValue])

            // Only update featured_selected_images if the field exists in the schema and has a value
            if (featuredImagesField && featuredImagesField.value && Array.isArray(featuredImagesField.value)) {
              setFeaturedImagesValue([...featuredImagesField.value, imageData])
            }
          } else {
            // Remove from both fields
            setSelectedImagesValue(selectedImagesField.value.filter((url) => url !== checkboxValue))

            // Only update featured_selected_images if the field exists in the schema and has a value
            if (featuredImagesField && featuredImagesField.value && Array.isArray(featuredImagesField.value)) {
              setFeaturedImagesValue(featuredImagesField.value.filter((img) => img.url !== checkboxValue))
            }
          }
        }}
      >
        <div className={Styles.checkbox}>
          <Checkbox.Box color="var(--selected-fill)" />
        </div>
        <img src={url} alt={alt} className={Styles.image} />
      </Checkbox.Label>
    </div>
  )
}
